export const DEFAULT_LANG = "eng";
export const appName =
  (window.__BookingEngine_ServerData__ &&
    window.__BookingEngine_ServerData__.appName) ||
  "app";
export const serverURL = "http://localhost:8888";
export const submitRedirectURL = "/ExternalReservations/externalRegistration";

export const BREAD_CRUMBS_STEPS = {
  BOOK: "Book",
  RESERVE: "Reserve"
};

export const BREAD_CRUMBS_ROUTE_MAPPING = {
  deals: BREAD_CRUMBS_STEPS.BOOK,
  deal: BREAD_CRUMBS_STEPS.BOOK,
  hotel: BREAD_CRUMBS_STEPS.BOOK,
  city: BREAD_CRUMBS_STEPS.BOOK,
  region: BREAD_CRUMBS_STEPS.BOOK,
  all: BREAD_CRUMBS_STEPS.BOOK,
  registration: BREAD_CRUMBS_STEPS.RESERVE,
  payment: BREAD_CRUMBS_STEPS.RESERVE,
  confirmation: BREAD_CRUMBS_STEPS.RESERVE
};

export const LAST_CURRENCY = "LAST_CURRENCY";

export const DEALS_SEARCH_BOX_LOCATION =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:8888"
    : document.location.origin;

export const USER_COMMENTS_SS_KEY = "USER_COMMENTS_SS_KEY";

export const paypalImgEng = "/Content/HotelContent/images/paypal.png";
export const paypalImgHeb = "/Content/HotelContent/images/paypal_heb.png";



// WEBPACK FOOTER //
// ./src/constants/constants.js